import React from "react";
import { useDependencyInjector } from "@whatslly/commons/di";
import type { IUserStore } from "@whatslly/ui-components/services/UserStore";
import { InjectUserStore } from "@whatslly/ui-components/services/UserStore";
import { observer } from "mobx-react-lite";

export const JumpPage: React.FC = observer(() => {
  const userStore = useDependencyInjector<IUserStore>(InjectUserStore);
  userStore.logout();
  document.location.href = "https://jump.tuvis.com";

  /* istanbul ignore next -- @preserve */
  return null;
});
